"use strict";

define('rs/form/formobjects/check/check.formobject',['rs/form/formobjects/base.formobject', 'rs/form/formobjects/check/check.formobject.view'], function (BaseFormObject, CheckFormObjectView) {
  var CheckFormObject = BaseFormObject.extend({
    defaultValue: false,
    propertiesDefinitions: ['name', 'text'],
    linksDefinitions: ['link.displayed', 'link.required'],
    isAnswerable: true,
    isBoolean: true,
    isCommentable: function isCommentable() {
      var siblings = this.getParent().getChildren(),
        i = 0,
        len = siblings.length,
        type = this.getType();
      if (len == 1) {
        return true;
      }
      for (i = 0; i < len; ++i) {
        if (siblings[i].getType() !== type) {
          return true;
        }
      }
      return false;
    },
    isCompoundChild: function isCompoundChild() {
      return true;
    },
    setupView: function setupView() {
      this.setView(new CheckFormObjectView());
    },
    canBeLinkedFromFormObject: function canBeLinkedFromFormObject(linker, type) {
      if (type == "required") {
        return false;
      }
      return this._super.apply(this, arguments);
    },
    getCompareValue: function getCompareValue() {
      return !!this.getValue();
    }
  }, {
    getTypeString: function getTypeString() {
      return 'CheckBox';
    }
  });
  return CheckFormObject;
});

